export interface ItemList {
  title: string
  slug: string
  locale: string
  handles: Array<string>
}

export interface CreateItemListOptions {
  title?: string
  slug?: string
  locale?: string
  handles?: Array<string>
}

export const createItemList = (obj: CreateItemListOptions): ItemList => {
  const list: ItemList = {
    title: '',
    slug: 'default',
    locale: 'en-us',
    handles: [],
    ...obj
  }

  return list
}
